import { DateTime } from 'luxon'

const COUNTDOWN_CUTOFF = 5 * 60 * 1000

const EducationEmbedCountdown = {
  mounted() {
    this.displayCountdownText = this.el.querySelector('[data-embed-countdown="count"]')
    this.displayCountdownSoon = this.el.querySelector('[data-embed-countdown="soon"]')
    this.displayCountdownTime = this.el.querySelector('[data-embed-countdown-time]')
    this.countdown = DateTime.fromISO(this.displayCountdownTime.getAttribute('data-embed-countdown-time'))

    this.countdownInterval = setInterval(() => {
      this.tick()
    }, 500);
  },
  destroyed() {
    clearInterval(this.countdownInterval)
  },
  tick() {
    const tick = this.countdown.diffNow()

    if (tick.milliseconds > COUNTDOWN_CUTOFF) {
      this.displayCountdownText.classList.remove('hidden')
      this.displayCountdownSoon.classList.add('hidden')
      this.displayCountdownTime.innerText = tick.toFormat("hh'h' mm'm' ss's'")
    } else {
      this.displayCountdownText.classList.add('hidden')
      this.displayCountdownSoon.classList.remove('hidden')

      clearInterval(this.countdownInterval)
    }
  },
}

export default EducationEmbedCountdown
